import { createContext, useContext } from 'react';

export const ReviewNoticeKind = {
  // Another model's review of identical data was carried over to this one.
  INHERITED: 'inherited',
  // Other models share this exact data, so one review covers them all.
  IDENTICAL: 'identical',
  // Still loading the other models to compare against.
  CHECKING: 'checking'
} as const;
export type ReviewNoticeKindType = (typeof ReviewNoticeKind)[keyof typeof ReviewNoticeKind];

// A cross-model note about the active review step, shown as a chip in its section
// header so the reviewer sees it before reading any data. `detail` is the full
// sentence, shown on hover.
export interface ReviewNotice {
  kind: ReviewNoticeKindType;
  label: string;
  detail: string;
  // Tooltip for the review bar's Approve button: who else this decision carries over to.
  approveHint?: string;
}

export const ReviewNoticeContext = createContext<ReviewNotice | undefined>(undefined);

export const useReviewNotice = (): ReviewNotice | undefined => useContext(ReviewNoticeContext);
